import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { StatusPill } from 'screens/Schedule/ScheduleStatusBanner/StatusPill'
import { Dayjs } from 'dayjs'
import { useMemo } from 'react'

dayjs.extend(utc)

interface Props {
  approvalDate?: Dayjs
}

export const ReadyStatusPill = ({ approvalDate }: Props) => {
  const label = useMemo(() => {
    const daysUntil = dayjs.utc(approvalDate).startOf('day').diff(dayjs.utc().startOf('day'), 'day')
    if (daysUntil > 5) return `Generating on ${approvalDate?.format('MMM D')}`
    if (daysUntil < 1) return 'Generating today'
    if (daysUntil < 2) return 'Generating tomorrow'
    return `Generating in ${daysUntil} days`
  }, [approvalDate])

  return <StatusPill status="generating">{label}</StatusPill>
}
